import AXIOS from "@/axios";
import {
  ProjectFilterListResponse,
  ProjectHoursPurchaseList,
  ProjectList,
  ProjectMonthlyAnalytics,
  ProjectQuery,
} from "@/types/project.model";

import { APIResponse } from "@/types/user.model";
import { removeEmptyProps } from "@/utils/constants";

export const getServicesFilterListService = () => {
  return AXIOS.get<APIResponse<string[]>>("/base/dn/v1/service");
};

export const getProjectFilterListService = ({
  search,
  userId,
  clientId,
  projectType,
}: {
  search: string;
  userId?: string;
  clientId?: string;
  projectType?: string;
}) => {
  const params: { [key: string]: string } = {};

  if (search) {
    params["search"] = search;
  }

  if (userId) {
    params["userId"] = userId;
  }

  if (clientId) {
    params["clientId"] = clientId;
  }

  if (projectType) {
    params["projectType"] = projectType;
  }

  return AXIOS.get<APIResponse<ProjectFilterListResponse[]>>(
    "/base/dn/v1/project",
    {
      params,
    }
  );
};

export const createProjectService = (payload: any) => {
  return AXIOS.post<APIResponse<ProjectList>>("/project/v1/create", payload);
};

export const updateProjectService = (projectId: string, payload: any) => {
  return AXIOS.put<APIResponse<ProjectList>>(
    `/project/v1/update/${projectId}`,
    payload
  );
};

export const getProjectDetailService = (projectId: string) => {
  return AXIOS.get<APIResponse<ProjectList>>(`/project/v1/view/${projectId}`);
};

export const getAllProjectsService = (query: ProjectQuery) => {
  return AXIOS.get<APIResponse<ProjectList[]>>("/project/v1/list", {
    params: query,
  });
};

export const deleteProjectService = (projectId: string) => {
  return AXIOS.delete<{ message: string }>(`/project/v1/delete/${projectId}`);
};

export const getProjectMonthlyBreakdownService = (projectId: string) => {
  return AXIOS.get<APIResponse<ProjectMonthlyAnalytics>>(
    `/project/v1/analytics/${projectId}`
  );
};

export const downloadProjectReport = (
  type: "pdf" | "csv",
  params: ProjectQuery
) => {
  return AXIOS.get(`/project/v1/download/${type}`, {
    params: removeEmptyProps(params),
    responseType: "blob",
  });
};

export const projectHoursPurchaseListService = (projectId: string) => {
  return AXIOS.get<APIResponse<ProjectHoursPurchaseList[]>>(
    `/project/v1/prchs/${projectId}`
  );
};

export const projectPurchaseDownload = (
  type: "pdf" | "csv",
  projectId: string
) => {
  return AXIOS.get(`/project/v1/prchs/download/${type}/${projectId}`, {
    responseType: "blob",
  });
};
